import Field, { FieldProps } from '../field/Field';
import React, { useState } from 'react';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/solid';

interface PasswordFieldProps extends Omit<FieldProps, 'type'> {}

const PasswordField = (props: PasswordFieldProps) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Field
      aria-label="Password field"
      aria-roledescription="Password input field. Hides charcters by default, can toggle hide by clicking or navigating to icon and doing any key press."
      type={showPassword ? 'text' : 'password'}
      endIconProps={{
        ariaLabel: showPassword ? 'Hide password' : 'Show password',
      }}
      endIcon={showPassword ? <EyeSlashIcon /> : <EyeIcon />}
      endIconAction={() => setShowPassword(!showPassword)}
      {...props}
    />
  );
};

export default PasswordField;
